
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[countryCode]/product/search",
      function () {
        return require("private-next-pages/[countryCode]/product/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[countryCode]/product/search"])
      });
    }
  